import { ArrowUpRight, Check, UtensilsCrossed } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { demonstrations } from "@/data/demonstrations";

export const Demonstrations = () => (
  <section
    id="experimente"
    aria-labelledby="experimente-title"
    className="relative scroll-mt-24 py-28 md:py-40 border-t border-white/5 bg-[#070707]"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <Overline>Demonstrações interativas</Overline>
        <h2
          id="experimente-title"
          className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6 max-w-[22ch]"
        >
          Experimente nossas soluções
        </h2>
        <p className="mt-6 text-neutral-400 text-base md:text-lg leading-relaxed max-w-[64ch]">
          Veja como sites, Web Apps e soluções digitais podem ajudar uma operação.
          Abra uma demonstração por segmento e explore no seu próprio ritmo,
          sem instalação ou login.
        </p>
        <p className="mt-4 text-neutral-500 text-sm leading-relaxed max-w-[72ch]">
          As experiências abaixo são demonstrações da Roda.IA com negócios
          fictícios. Não são casos reais de clientes ou parceiros.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6">
        {demonstrations.map((demo) => (
          <Reveal key={demo.id}>
            <article
              data-testid={`demo-${demo.id}`}
              className="border border-white/10 bg-[#0a0a0a] rounded-sm overflow-hidden grid lg:grid-cols-[1fr_0.65fr]"
            >
              <div className="p-7 md:p-10">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-neutral-400">
                    {demo.segment}
                  </span>
                  <span className="border border-white/15 px-2 py-1 text-[10px] font-mono uppercase tracking-widest text-neutral-300">
                    Demonstração
                  </span>
                </div>
                <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mt-6 max-w-[26ch]">
                  {demo.title}
                </h3>
                <p className="mt-4 max-w-[62ch] text-neutral-400 text-sm md:text-base leading-relaxed">
                  {demo.description}
                </p>
                <ul className="mt-6 flex flex-col gap-3 text-sm text-neutral-300">
                  {demo.benefits.map((benefit) => (
                    <li key={benefit} className="flex items-start gap-2.5">
                      <Check className="w-4 h-4 shrink-0 mt-0.5" aria-hidden="true" />
                      {benefit}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  {demo.url ? (
                    <a
                      href={demo.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="demo-restaurante-cta"
                      className="inline-flex items-center justify-center gap-2 bg-white text-black font-semibold text-sm px-6 py-4 rounded-sm hover:bg-neutral-200 transition-colors w-full sm:w-auto"
                    >
                      Experimentar demonstração
                      <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
                      <span className="sr-only">(abre em nova aba)</span>
                    </a>
                  ) : (
                    <button
                      type="button"
                      disabled
                      data-testid="demo-restaurante-cta"
                      className="border border-white/15 bg-white/5 text-neutral-400 font-semibold text-sm px-6 py-4 rounded-sm w-full sm:w-auto cursor-not-allowed"
                    >
                      Demonstração em preparação
                    </button>
                  )}
                  <p className="mt-3 text-xs leading-relaxed text-neutral-500">
                    Sem pedidos, pagamentos ou reservas reais. Nenhuma integração
                    de produção é utilizada.
                  </p>
                </div>
              </div>
              <div className="border-t lg:border-t-0 lg:border-l border-white/10 bg-[#101010] p-7 md:p-10 flex flex-col justify-between gap-10" aria-hidden="true">
                <div className="flex justify-between items-center text-neutral-500 font-mono text-[10px] tracking-widest uppercase">
                  <span>Mesa do Largo</span>
                  <UtensilsCrossed className="w-5 h-5" />
                </div>
                <div>
                  <div className="flex gap-2 mb-7 text-[10px] font-mono text-neutral-500">
                    <span className="border border-white/15 px-2 py-1">PT</span>
                    <span className="border border-white/10 px-2 py-1">EN</span>
                  </div>
                  <p className="font-display font-bold text-3xl md:text-4xl tracking-tight leading-tight text-neutral-200">
                    Da ementa<br />à conversa.
                  </p>
                  <div className="mt-8 space-y-3">
                    {["Ementa digital", "Atendimento", "Pedido de mesa simulado"].map((text) => (
                      <div key={text} className="border-b border-white/10 pb-3 text-sm text-neutral-500">{text}</div>
                    ))}
                  </div>
                </div>
                <p className="text-[10px] font-mono text-neutral-600 uppercase tracking-widest">Restaurante fictício · Roda.IA</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
